export const REFERRAL_SETTINGS_DEFAULT_VALUES = {
  rewardValue: 2000,
  freeSpinsCount: 5,
  freeSpinsRewardChance: 90,
  firstSpinRewardMinPercent: 0,
  firstSpinRewardMaxPercent: 0,
  defaultSpinRewardMinPercent: 0,
  defaultSpinRewardMaxPercent: 0,
  requiredTasksForReferralValidate: 0,
  rewardsChances: [],
  startDate: new Date(),
};

export const REFERRAL_REWARD_SETTINGS_DEFAULT_VALUES = {
  inviterRewards: [],
  referralRewards: [],
  isActive: false,
  requiredTasksForValidate: 1,
};

export const REFERRAL_ASSIGN_DEFAULT_VALUES = {
  referralTelegramNickname: '',
};

export enum ReferralRewardTabsEnum {
  REFERRAL_SYSTEM_SETTINGS = 'Referral system settings',
  REFERRAL_VALIDATION_SETTINGS = 'Referral validation settings',
}
